import { BaseDivHomePage } from '@/main/components/layouts/homepageLayout/styles';
import styled, { css } from 'styled-components';

export const clipPathBothom = css`
  clip-path: polygon(
    0% 98.276%,
    0% 1.724%,
    0% 1.724%,
    0.039% 1.444%,
    0.151% 1.179%,
    0.33% 0.932%,
    0.571% 0.706%,
    0.867% 0.505%,
    1.212% 0.333%,
    1.6% 0.192%,
    2.025% 0.088%,
    2.48% 0.023%,
    2.961% 0%,
    97.039% 0%,
    97.039% 0%,
    97.52% 0.023%,
    97.975% 0.088%,
    98.4% 0.192%,
    98.788% 0.333%,
    99.133% 0.505%,
    99.429% 0.706%,
    99.67% 0.932%,
    99.849% 1.179%,
    99.961% 1.444%,
    100% 1.724%,
    100% 93.766%,
    100% 93.766%,
    99.961% 94.046%,
    99.849% 94.311%,
    99.67% 94.558%,
    99.429% 94.784%,
    99.133% 94.985%,
    98.788% 95.157%,
    98.4% 95.298%,
    97.975% 95.402%,
    97.52% 95.467%,
    97.039% 95.49%,
    39.867% 95.49%,
    39.867% 95.49%,
    39.593% 95.497%,
    39.324% 95.519%,
    39.061% 95.555%,
    38.806% 95.605%,
    38.56% 95.667%,
    38.325% 95.742%,
    38.102% 95.83%,
    37.893% 95.929%,
    37.699% 96.04%,
    37.522% 96.162%,
    33.333% 99.329%,
    33.333% 99.329%,
    33.156% 99.45%,
    32.962% 99.561%,
    32.753% 99.66%,
    32.53% 99.748%,
    32.295% 99.823%,
    32.049% 99.886%,
    31.794% 99.935%,
    31.531% 99.971%,
    31.262% 99.993%,
    30.988% 100%,
    2.961% 100%,
    2.961% 100%,
    2.48% 99.977%,
    2.025% 99.912%,
    1.6% 99.808%,
    1.212% 99.667%,
    0.867% 99.495%,
    0.571% 99.294%,
    0.33% 99.068%,
    0.151% 98.821%,
    0.039% 98.556%,
    0% 98.276%
  );
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: left;
  gap: 3rem;
  justify-content: flex-start;
  > button {
    max-width: 250px;
    border-radius: 10px;
  }
`;

export const AreaInputNumber = styled.div`
  position: relative;
  &&& {
    .MuiAutocomplete-inputRoot {
      background: ${({ theme }) => theme.grayLight};
      margin: 14px 44px 0px 0px;
      padding: 0;
      border-radius: 2px;
    }
    svg {
      background: none !important;
    }
  }
`;

export const FieldText = styled.div`
  font-size: 1rem;
  text-align: left;
  color: #ffffff;
  line-height: normal;
  margin: 0, auto;
  > span {
    display: block;
  }
`;

export const TitleLandingPage = styled.div`
  font-size: 3rem;
  font-weight: bold;
  color: #ffffff;
  text-align: left;
`;

export const FieldText2 = styled.div`
  /* margin-top: 20px; */
  padding: 1rem 0 0 0;
  font-size: 1rem;
  margin: 0;
  text-align: left;
  color: #181f26;
  .MuiTypography-body1 {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-size: 1rem;
    color: black;
  }
`;

export const FieldPrivacePolicy = styled.div`
  padding: 0 0 1rem 0;

  font-size: 1rem;
  margin: 0;
  text-align: left;
  color: #181f26;
  .MuiTypography-body1 {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-size: 1rem;
    color: black;
  }
`;

export const FieldCheckBox = styled.div`
  font-size: 1rem;
  margin: 0;
  text-align: left;
  color: #181f26;
  .MuiTypography-body1 {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-size: 1rem;
    color:black;
    text-overflow: clip;
    white-space: normal;
  }

  .MuiFormControlLabel-root {
    margin: 0 -11px -2px -12px;
  }
`;

export const FieldTextInitial = styled.div`
  margin-top: 0px;
  text-align: left;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  color: #3f5ec9;
  text-align: left;
`;

export const AreaForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 1rem;
  background: ${({ theme }) => theme.pantone656C};
  padding: 2rem 1rem 4rem 1rem;
  border-radius: 8px;
  width: 100%;
  ${clipPathBothom}
`;

export const AreaText = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 8px;
`;

export const Container = styled(BaseDivHomePage)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 1rem;
  padding: 2rem 3rem 0 3rem;
  width: 100%;
  line-height: normal;
  > ${AreaText} {
    width: 55%;
  }
  > form {
    width: 45%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    > ${AreaText} {
      width: 100%;
    }
    > form {
      width: 100%;
    }
  }
`;

export const ImageLine = styled.img`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
  }
`;

